import { Component } from '@angular/core';

@Component({
  selector: 'app-extras',
  templateUrl: './extras.component.html',
  styleUrls: ['./extras.component.scss']
})
export class ExtrasComponent {
  isModalOpen: boolean = false;
  selectedCard: string = '';

  openModal(cardType: string) {
    this.selectedCard = cardType;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}